import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c613be9c")

_pushScopeId("data-v-c613be9c")
const _hoisted_1 = { class: "board__outside" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BoardCard = _resolveComponent("BoardCard")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.boardConfigAsObject, (value, key, mainIndex) => {
      return (_openBlock(), _createBlock("div", {
        key: key,
        class: { [`board__outside-${key}`]: true }
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(value, (card, i) => {
          return (_openBlock(), _createBlock(_component_BoardCard, {
            key: `card_${i + 10 * mainIndex}`,
            card: card,
            players: _ctx.players,
            "bonus-money": _ctx.bonusMoney,
            charge: _ctx.getCardCharge(card),
            "your-player-highlight": i + 10 * mainIndex === _ctx.yourPlayer.boardField,
            "your-player": _ctx.yourPlayer,
            onTogglePreviewedCard: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('togglePreviewedCard', $event)))
          }, null, 8, ["card", "players", "bonus-money", "charge", "your-player-highlight", "your-player"]))
        }), 128))
      ], 2))
    }), 128))
  ]))
})